import React, { useState, useReducer, useRef } from "react";

import {
  Grid,
  Input,
  TextareaAutosize,
  Button,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Loader from "components/Loader";
import PropTypes from "prop-types";
import { InviteOrganizationFormReducer } from "reducers/formReducers";
import tagAdminConstants from "constants/tagAdminConstants";
import ImageCropperModal from "components/ImageCrop";

const initialValue = {
  email: "",
  companyName: "",
  address: "",
  errors: {},
  additionaldetails: "",
  organizationImage: null,
  organization_type: tagAdminConstants.APP_MODE.LIGHT.key,
};

function InviteOrganization({ handleResponse }) {
  const [formState, dispatch] = useReducer(
    InviteOrganizationFormReducer,
    initialValue
  );
  const [openLoaderModal, setOpenLoaderModal] = useState(false);
  const [openCropModal, setOpenCropModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const errorMessage = formState.errors?.issues;
  const hiddenFileInput = useRef(null);

  const {
    email,
    companyName,
    address,
    sub_domain,
    errors,
    additionaldetails,
    organizationImage,
    organization_type,
  } = formState;
  const onChange = (e) => {
    console.log("e.target.name", e.target.name);
    console.log("e.target.value", e.target.value);

    dispatch({
      type: e.target.name,
      payload: {
        field: e.target.name,
        value: e.target.value,
      },
    });
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const imageValidation = (imagetype) => {
    let validImageType = false;
    const imagetypeValid = imagetype.name.match(
      tagAdminConstants.UPLOAD_IMAGE_PATTERN_REGEX
    );
    if (!imagetypeValid) {
      validImageType = true;
    }
    return validImageType;
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    const checkValidImage = imageValidation(fileUploaded);
    if (checkValidImage) {
      const issues = {};
      issues.organizationImage = "*Please select valid image.";
      dispatch({
        type: "validation",
        payload: {
          issues,
        },
      });
      return;
    }
    dispatch({
      type: "organizationImage",
      payload: {
        fileUploaded,
      },
    });
    const reader = new FileReader();
    reader.onload = () => {
      setUploadedImage(reader.result);
      setOpenCropModal(true); // open crop modal
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  // Called after user crops and saves
  const handleCropDone = ({ blob, fileUrl }) => {
    dispatch({
      type: "organizationImage",
      payload: { fileUploaded: blob },
    });
    const output = document.getElementById("organizationImageOutput");
    if (output) output.src = fileUrl;
    setOpenCropModal(false);
  };

  // validation function
  const validateForm = () => {
    let formIsValid = true;
    const issues = {};
    if (!email) {
      formIsValid = false;
      issues.email = "*Please enter organization email.";
    } else if (typeof email !== "undefined") {
      // regular expression for email validation
      const pattern = tagAdminConstants.EMAIL_PATTERN_REGEX;

      if (!pattern.test(email)) {
        formIsValid = false;
        issues.email = "*Please enter valid email.";
      }
    }
    if (!address) {
      formIsValid = false;
      issues.address = "*Please enter organization address.";
    }
    // if (!additionaldetails) {
    //   formIsValid = false;
    //   issues.details = "*Please enter organization details.";
    // }
    if (!companyName) {
      formIsValid = false;
      issues.companyName = "*Please enter organization title.";
    }
    if (!sub_domain) {
      formIsValid = false;
      issues.sub_domain = "*Please enter valid sub-domain.";
    }
    // if (!organizationImage) {
    //   formIsValid = false;
    //   issues.organizationImage = "*Please select organization image.";
    // }
    if (
      organizationImage &&
      !organizationImage.name.match(
        tagAdminConstants.UPLOAD_IMAGE_PATTERN_REGEX
      )
    ) {
      formIsValid = false;
      issues.organizationImage = "*Please select valid image.";
    }
    dispatch({
      type: "validation",
      payload: {
        issues,
      },
    });
    return formIsValid;
  };

  const addNewOrganization = (e) => {
    e.preventDefault();
    setOpenLoaderModal(true);
    if (validateForm() === false) {
      setOpenLoaderModal(false);
    } else {
      const data = new FormData();
      data.append("email", email);
      data.append("title", companyName);
      data.append("address", address);
      data.append("details", additionaldetails);
      if (organizationImage) {
        data.append("logo", organizationImage);
      }
      data.append("sub_domain", sub_domain);
      data.append("is_blocked", 0);
      data.append("organization_type", organization_type);
      handleResponse(data);
    }
  };

  return (
    <div className="b-modal-container">
      <Loader title="Adding Organization" openLoader={openLoaderModal} />
      <form onSubmit={addNewOrganization} className="b-modal-container__form">
        <Grid container spacing={4}>
          <Grid item md={3.5} xs={12}>
            {organizationImage === null ? (
              <>
                <button
                  className="b-modal-container__button-logo"
                  type="button"
                  onClick={(event) => handleClick(event)}
                >
                  Add Logo
                </button>
                <input
                  className="b-organization-container__file"
                  type="file"
                  ref={hiddenFileInput}
                  name
                  onChange={handleChange}
                  accept="image/*"
                />
                <div className="errorMsg">
                  {" "}
                  {errorMessage?.organizationImage}
                </div>
              </>
            ) : (
              <>
                <button
                  type="button"
                  onClick={(event) => handleClick(event)}
                  className="b-modal-container__button-logo"
                >
                  <img
                    alt=""
                    id="organizationImageOutput"
                    style={{
                      width: "100%",
                      height: "auto",
                      aspectRatio: "1 / 1",
                      objectFit: "contain",
                      borderRadius: "8px",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </button>
                <input
                  className="b-organization-container__file"
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleChange}
                  accept="image/*"
                />
                {errors && errors.validOrganizationImag && (
                  <div className="errorMsg">
                    {errors.validOrganizationImage}
                  </div>
                )}
              </>
            )}
          </Grid>
          <Grid item md={8.5} xs={12} gap={1}>
            {/* File Information */}
            <InputLabel
              htmlFor="email"
              className="font-bold  b-organization-container__label"
            >
              Primary Email
            </InputLabel>

            <Input
              id="email"
              className="dafault-font-family b-organization-container__input"
              value={email}
              name="email"
              variant="standard"
              onChange={onChange}
            />
            {errorMessage && errorMessage?.email !== "" && (
              <div className="errorMsg">{errorMessage?.email}</div>
            )}
            <div className="b-organization-container__detailHead">
              <InputLabel
                htmlFor="companyname"
                className="font-bold b-organization-container__companyLabel"
              >
                Company Name
              </InputLabel>

              <Input
                id="companyName"
                name="companyName"
                className="dafault-font-family b-organization-container__companyname"
                variant="standard"
                value={companyName}
                onChange={onChange}
              />
              {errorMessage && errorMessage?.companyName !== "" && (
                <div className="errorMsg">{errorMessage?.companyName}</div>
              )}
            </div>
            <div className="b-organization-container__address b-organization-container__detailHead">
              <InputLabel
                htmlFor="address"
                className="font-bold b-organization-container__companyLabel"
              >
                Address
              </InputLabel>

              {/* address input */}
              <Input
                id="address"
                name="address"
                className="dafault-font-family b-organization-container__address"
                variant="standard"
                onChange={onChange}
                value={address}
              />
              {errorMessage && errorMessage?.address !== "" && (
                <div className="errorMsg">{errorMessage?.address}</div>
              )}
            </div>

            {/* sub_domain input */}
            <div className="b-organization-container__domain b-organization-container__detailHead">
              <InputLabel
                htmlFor="sub_domain"
                className="font-bold b-organization-container__domainLabel"
              >
                Domain
              </InputLabel>

              <Input
                id="sub_domain"
                name="sub_domain"
                className="dafault-font-family b-organization-container__domain"
                variant="standard"
                onChange={onChange}
                value={sub_domain}
              />
              {errorMessage && errorMessage?.sub_domain !== "" && (
                <div className="errorMsg">{errorMessage?.sub_domain}</div>
              )}
            </div>

            <div className="b-organization-container__detailHead">
              <InputLabel
                htmlFor="additionaldetails"
                className="font-bold b-organization-container__detail"
              >
                Additional Details
              </InputLabel>

              <TextareaAutosize
                id="additionaldetails"
                name="additionaldetails"
                className="dafault-font-family b-organization-container__textArea"
                aria-label="minimum height"
                minRows={6}
                onChange={onChange}
                value={additionaldetails}
              />
              {errorMessage && errorMessage.details !== undefined && (
                <div className="errorMsg"> {errorMessage.details} </div>
              )}
            </div>
            <div className="b-organization-container__detailHead">
              <InputLabel
                htmlFor="organization_type"
                className="font-bold b-organization-container__companyLabel"
              >
                Organization type
              </InputLabel>
              <Select
                id="organization_type"
                name="organization_type"
                value={organization_type}
                className="font-bold t-select-dropdown"
                onChange={onChange}
              >
                <MenuItem value={tagAdminConstants.APP_MODE.LIGHT.key}>
                  {tagAdminConstants.APP_MODE.LIGHT.value}
                </MenuItem>
                <MenuItem value={tagAdminConstants.APP_MODE.FULL.key}>
                  {tagAdminConstants.APP_MODE.FULL.value}
                </MenuItem>
              </Select>
            </div>
            <div className="b-organization-container__buttonHead">
              <Button
                className="b-btn-container__btn-add-new"
                variant="outlined"
                cssName="add-new-user"
                onClick={addNewOrganization}
              >
                <AddIcon />
                Add New Organization
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
      <ImageCropperModal
        open={openCropModal}
        onClose={() => setOpenCropModal(false)}
        imageSrc={uploadedImage}
        onCropDone={handleCropDone}
      />
    </div>
  );
}

InviteOrganization.propTypes = {
  handleResponse: PropTypes.func.isRequired,
};

export default InviteOrganization;
